module.exports = __webpack_public_path__ + "img/ep8-3.4227ca3e.png";